import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useDispatch, useSelector } from "react-redux";

//Components
import Layout from "../../../../Layout/Layout";
import CustomerConstants from "../../../../common/CustomerConstants";

import { SearchField } from "../../../../Components/formElements/SearchField";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
// import ShowUploadImageV5 from "./ShowUploadImageV5";
import MultiColumnFilter from "../../../../Components/MultiColumnFilter/MultiColumnFilter";
import {
  //   getMaterialList,
  materialBarcodeList,
} from "../../../../redux/feature/customer_app/customerSlice";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import { formatDate } from "../../../../common/Validations";
import MaterialListQualityCheckModal from "./MaterialListQualityCheckModal";
import "./ageingReport.css";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ItemService from "../../../../services/customer_appCommonService";

const RentMaterialAgeingReport = () => {
  localStorage.setItem("menu", "Idle Ageing");
  localStorage.setItem("submenu", "Rent Product Idle Ageing");

  const dispatch = useDispatch();

  let materialData = useSelector(
    (state) => state?.customer?.materialBarcode?.data,
  ); // User Details from Store

  let materialTable = useSelector(
    (state) => state?.customer?.materialBarcode?.pagination,
  );

  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [getNewPerPage, setNewPerPage] = useState(10);

  const [isCardVisible2, setCardVisible2] = useState(true);
  // eslint-disable-next-line
  const [getData, setData] = useState();
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  // eslint-disable-next-line
  const [getFileViewData, setFileViewData] = useState(null);
  const [activeBucket, setActiveBucket] = useState(null);
  // eslint-disable-next-line
  const [filteredData, setFilteredData] = useState([]);

  const [getTotlaMaterialBarcode, setTotlaMaterialBarcode] = useState();
  const [getMiniDay, setMiniDay] = useState(null);
  const [getMaxDay, setMaxDay] = useState(null);
  const [activeFilters, setActiveFilters] = useState([]);


  useEffect(() => {
    setFilteredData(materialData || []);
  }, [materialData]);
const handleBucketClick = (min, max, label) => {
  setMiniDay(min);
  setMaxDay(max);
  setActiveFilters([]); // ← clear column filters
  const obj = {
    queryName: "MaterilBarcodeListRE",
    page: 1,
    per_page: getNewPerPage,
    rowFilter: {
      $and: [{ ageingDays: { $gte: min, $lte: max } }],
    },
  };
  dispatch(materialBarcodeList(obj));
};
  // const handleBucketClick = (min, max, label) => {
  //   setMiniDay(min);
  //   setMaxDay(max);

  //   const obj = {
  //     queryName: "MaterilBarcodeListRE",
  //     page: 1,
  //     per_page: 10,
  //     rowFilter: {
  //       $and: [
  //         {
  //           ageingDays: {
  //             $gte: min,
  //             $lte: max,
  //           },
  //         },
  //       ],
  //     },
  //   };
  //   dispatch(materialBarcodeList(obj));

  //   // setActiveBucket(label);

  //   // const filtered = materialData.filter((row) => {
  //   //   const days = row.ageingDays;

  //   //   if (max === "above") {
  //   //     return days > min;
  //   //   }
  //   //   return days >= min && days <= max;
  //   // });

  //   // setFilteredData(filtered);
  // };

  const clearBucketFilter = () => {
    setActiveBucket(null);
    setFilteredData(materialData);
  };

  const getRoiExpiryDate = (createdOn) => {
    if (!createdOn) return null;

    const date = new Date(createdOn);
    date.setMonth(date.getMonth() + 36);

    return date; // return Date object
  };

  const getRoiAgeMonthsDays = (createdOn) => {
    if (!createdOn) return "--";

    const start = new Date(createdOn);
    const today = new Date();

    if (today < start) return "0 Days";

    let years = today.getFullYear() - start.getFullYear();
    let months = today.getMonth() - start.getMonth();
    let days = today.getDate() - start.getDate();

    if (days < 0) {
      // previous month days
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += prevMonth.getDate();
      months -= 1;
    }

    if (months < 0) {
      months += 12;
      years -= 1;
    }

    const totalMonths = years * 12 + months;

    let result = "";
    if (totalMonths > 0)
      result += `${totalMonths} Month${totalMonths > 1 ? "s" : ""} `;
    result += `${days} Day${days !== 1 ? "s" : ""}`;

    return result.trim();
  };

  const [qcType, setQcType] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [showQCModal, setShowQCModal] = useState(false);
  const [qualityCheckItems, setQualityCheckItems] = useState([]);

  useEffect(() => {
    if (!materialData || materialData.length === 0) return;

    const qcItems = [];

    materialData.forEach((row) => {
      // API lo already QC details unte
      if (row.qualityCheckDetails?.length) {
        row.qualityCheckDetails.forEach((qc) => {
          qcItems.push({
            ...row,
            ...qc, // modelMatch, brandMatch etc
            grnItemNr: qc.grnItemNr,
            qcType: qc.qcType,

            hasPhysicalQC: qc.qcType === "PHYSICAL",
            hasSpecificationQC: qc.qcType === "SPECIFICATION",
          });
        });
      }
    });

    setQualityCheckItems(qcItems);
  }, [materialData]);

  const handleViewQC = (type, row) => {
    const savedQC = qualityCheckItems.find(
      (item) => item.grnItemNr === row.grnItemNr && item.qcType === type,
    );

    setQcType(type);
    setSelectedRow({
      ...row,
      ...(savedQC || {}),
    });
    setShowQCModal(true);
  };
  // eslint-disable-next-line
  const handleCheckboxClick = (type, row, e) => {
    e.preventDefault();

    const isChecked =
      type === "PHYSICAL" ? row.hasPhysicalQC : row.hasSpecificationQC;

    if (isChecked) {
      // Already checked - view existing data
      handleViewQC(type, row);
    } else {
      handleQCCheck(type, row);
    }
  };
  const handleQCCheck = (type, row) => {
    // Find existing QC data
    const existingQC = qualityCheckItems.find(
      (item) => item.grnItemNr === row.grnItemNr && item.qcType === type,
    );

    setQcType(type);
    setSelectedRow({
      ...row,
      ...(existingQC || {}),
    });
    setShowQCModal(true);
  };

  const AgeCard = ({ title, count = 0, color, onClick }) => (
    <OverlayTrigger placement="bottom" overlay={<Tooltip>{title}</Tooltip>}>
      <div className="age-card" onClick={onClick}>
        <p>{title}</p>
        <h2 style={{ color }}>{count}</h2>
      </div>
    </OverlayTrigger>
  );

  // new
  const handleSaveQualityCheck = (qcPayload) => {
    setQualityCheckItems((prev) => {
      const index = prev.findIndex(
        (item) =>
          item.grnItemNr === qcPayload.grnItemNr &&
          item.qcType === qcPayload.qcType,
      );

      // UPDATE EXISTING
      if (index !== -1) {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          ...qcPayload,
          hasPhysicalQC: qcPayload.qcType === "PHYSICAL",
          hasSpecificationQC: qcPayload.qcType === "SPECIFICATION",
        };
        return updated;
      }

      // ADD NEW
      return [
        ...prev,
        {
          ...qcPayload,
          hasPhysicalQC: qcPayload.qcType === "PHYSICAL",
          hasSpecificationQC: qcPayload.qcType === "SPECIFICATION",
        },
      ];
    });
  };

  const isRentGodown = materialData?.some((row) => row.godown === "Rent");

  const rentOnlyColumns = [
    {
      name: "Created On",
      selector: (row) => row.createdOn || "--",
      cell: (row) => (
        <p className="m-0 p-0 pt-1 fw-bold text-success">
          {formatDate(row.createdOn)}
        </p>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "ROI (Months)",
      selector: (row) => row.roiCodeMonths || "--",
      cell: (row) => (
        <p className="m-0 p-0 pt-1 fw-bold text-primary">{row.roiCodeMonths}</p>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "ROI Expiry Date",
      selector: (row) =>
        getRoiExpiryDate(row.createdOn)
          ? formatDate(getRoiExpiryDate(row.createdOn))
          : "--",
      cell: (row) => {
        const expiryDate = getRoiExpiryDate(row.createdOn);
        return (
          <p className="m-0 p-0 pt-1 fw-bold text-primary">
            {expiryDate ? formatDate(expiryDate) : "--"}
          </p>
        );
      },
      sortable: true,
      width: "160px",
    },
    {
      name: "ROI Age",
      selector: (row) => getRoiAgeMonthsDays(row.createdOn || row.createdDate),
      cell: (row) => (
        <p className="m-0 p-0 pt-1 fw-bold text-primary">
          {getRoiAgeMonthsDays(row.createdOn || row.createdDate)}
        </p>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Monthly ROI Amt",
      selector: (row) => row.monthlyRoiAmount || "--",
      cell: (row) => (
        <p className="m-0 p-0 pt-1 fw-bold text-primary">
          {row.monthlyRoiAmount} INR
        </p>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "AC Asset Type",
      selector: (row) => row.acAssetType || "--",
      cell: (row) => (
        <p className="m-0 p-0 pt-1 fw-bold text-primary">{row.acAssetType}</p>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Asset Status",
      cell: (row) => (
        <TableStatusField
          status={row.assetActiveInactive ? "Active" : "Inactive"}
        />
      ),
      width: "130px",
    },
  ];

  const getAgeingBucket = (row) => {
    const days = row.ageingDays;

    if (days >= 0 && days <= 30) return "0-30";
    if (days >= 31 && days <= 60) return "31-60";
    if (days >= 61 && days <= 90) return "61-90";
    if (days >= 91 && days <= 180) return "91-180";
    if (days >= 181 && days <= 365) return "181-365";
    if (days > 365) return "Over 365";

    return "--";
  };
  const getBucketValue = (days, min, max) => {
    if (days >= min && days <= max) {
      return days;
    }
    return "--";
  };

  const columns = [
    {
      name: "Barcode Code",
      id: "barcode",
      // id1:"materialDescription",
      // dropDown: true,
      selector: (row) => row.barcode || "--",
      cell: (row) => (
        <div className="ms-2">
          <p className="m-0 p-0 pt-1 fw-medium">{row?.barcode} </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Code",
      id: "materialCode",
      // id1:"materialDescription",
      // dropDown: true,
      selector: (row) => row.productName || "--",
      cell: (row) => (
        // <div className="d-flex justify-content-center w-50 align-items-center cursor-pointer">

        <div className="flex justify-center items-center">
          <div className="ms-2">
            <p className="m-0 p-0 pt-1 fw-bold">{row?.materialCode} </p>

            <p className="m-0 p-0 pt-1 fw-bold text-success">
              {row.materialDescription}{" "}
            </p>
          </div>
        </div>
      ),
      sortable: true,
      width: "300px",
    },

    {
      name: "Rate",
      selector: (row) => row.unitPrice || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {row.orderPriceUnit ?? row.unitPrice}{" "}
          </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },

    ...(isRentGodown ? rentOnlyColumns : []),

    {
      name: "Godown",
      selector: (row) => row.godown,
      sortable: true,
      width: "130px",
      cell: (row) => {
        const value = row.godown;

        const color =
          value === "Rent" ? "red" : value === "Sale" ? "green" : "inherit";

        return <span style={{ color, fontWeight: 600 }}>{value}</span>;
      },
    },
    {
      name: "Ageing Days",
      selector: (row) => row.ageingDays ?? "--",
      cell: (row) => (
        <p className="m-0 p-0 fw-bold">{row.ageingDays ?? "--"}</p>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Ageing Bucket",
      // id:"",
      selector: (row) => getAgeingBucket(row),
      cell: (row) => {
        const bucket = getAgeingBucket(row);
        const color =
          bucket === "0-30"
            ? "green"
            : bucket === "31-60"
              ? "orange"
              : bucket === "61-90"
                ? "darkorange"
                : bucket === "91-180"
                  ? "red"
                  : bucket === "181-365"
                    ? "maroon"
                    : bucket === "Over 365"
                      ? "black"
                      : "inherit";

        return <span style={{ color, fontWeight: 600 }}>{bucket}</span>;
      },
      sortable: true,
      width: "150px",
    },
    {
      name: "Bucket 0-30",
      cell: (row) => (
        <p className="m-0 p-0 fw-bold text-success">
          {getBucketValue(row.ageingDays, 0, 30)}
        </p>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Bucket 31-60",
      cell: (row) => (
        <p className="m-0 p-0 fw-bold text-warning">
          {getBucketValue(row.ageingDays, 31, 60)}
        </p>
      ),
      sortable: true,
      width: "160px",
    },

    {
      name: "Bucket 61-90",
      cell: (row) => (
        <p className="m-0 p-0 fw-bold text-dark-orange">
          {getBucketValue(row.ageingDays, 61, 90)}
        </p>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Bucket 91-180",
      cell: (row) => (
        <p className="m-0 p-0 fw-bold text-danger">
          {getBucketValue(row.ageingDays, 91, 180)}
        </p>
      ),
      sortable: true,
      width: "160px",
    },

    {
      name: "Bucket 181-365",
      cell: (row) => (
        <p className="m-0 p-0 fw-bold text-maroon">
          {getBucketValue(row.ageingDays, 181, 365)}
        </p>
      ),
      sortable: true,
      width: "160px",
    },

    {
      name: "Bucket 365 Above",
      cell: (row) => (
        <p className="m-0 p-0 fw-bold text-inherit">
          {row.ageingDays > 365 ? row.ageingDays : "--"}
        </p>
      ),
      sortable: true,
      width: "160px",
    },
  ];

  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  // const handleViewFile = (fileAttachmentId) => {
  //   setFileViewData(fileAttachmentId);
  //   setShowFileViewModal(true);
  // };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let obj = {
          queryName: "MaterilBarcodeListRE",
          page: 1,
          per_page: 10,
        };

        dispatch(materialBarcodeList(obj));
      } catch (error) {
        console.error("API Error:", error);
      }
    };

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let obj1 = {
          queryName: "MaterilBarcodeListRE",
          page: 1,
          per_page: 9999999999,
        };

        const res = await ItemService.generateQuery(obj1);

        if (res?.status === 200) {
          setTotlaMaterialBarcode(res.data || []);
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    };

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [materialTable]);

  // const handlePageChange = (page) => {
  //   let obj = {
  //     queryName: "MaterilBarcodeListRE",
  //     page: page,
  //     per_page: getNewPerPage,
  //   };

  //   if (getMiniDay !== null && getMaxDay !== null) {
  //     obj.rowFilter = {
  //       $and: [
  //         {
  //           ageingDays: {
  //             $gte: getMiniDay,
  //             $lte: getMaxDay,
  //           },
  //         },
  //       ],
  //     };
  //   }
  //   dispatch(materialBarcodeList(obj));
  // };
  const handlePageChange = (page) => {
  let obj = {
    queryName: "MaterilBarcodeListRE",
    page: page,
    per_page: getNewPerPage,
  };

  if (getMiniDay !== null && getMaxDay !== null) {
    // bucket filter takes priority
    obj.rowFilter = {
      $and: [{ ageingDays: { $gte: getMiniDay, $lte: getMaxDay } }],
    };
  } else if (activeFilters.length > 0) {
    // column filter
    obj.rowFilter = { $and: activeFilters };
  }

  dispatch(materialBarcodeList(obj));
};

const handlePerRowsChange = async (newPerPage, page) => {
  setNewPerPage(newPerPage);
  let obj = {
    queryName: "MaterilBarcodeListRE",
    page: page,
    per_page: newPerPage,    // ← was getNewPerPage (bug!) 
  };

  if (getMiniDay !== null && getMaxDay !== null) {
    obj.rowFilter = {
      $and: [{ ageingDays: { $gte: getMiniDay, $lte: getMaxDay } }],
    };
  } else if (activeFilters.length > 0) {
    obj.rowFilter = { $and: activeFilters };
  }

  dispatch(materialBarcodeList(obj));
};
  // const handlePerRowsChange = async (newPerPage, page) => {
  //   let obj = {
  //     queryName: "MaterilBarcodeListRE",
  //     page: page,
  //     per_page: getNewPerPage,
  //   };

  //   if (getMiniDay !== null && getMaxDay !== null) {
  //     obj.rowFilter = {
  //       $and: [
  //         {
  //           ageingDays: {
  //             $gte: getMiniDay,
  //             $lte: getMaxDay,
  //           },
  //         },
  //       ],
  //     };
  //   }
  //   setNewPerPage(newPerPage);
  //   dispatch(materialBarcodeList(obj));
  // };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "MaterilBarcodeListRE",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(materialBarcodeList(obj));
  };
  // const [data, setDataFilter] = useState();
  const [filterShow, setFilterShow] = useState(false);

  // const handleFilterData = async (filters) => {
  //   const obj = {
  //     queryName: "MaterilBarcodeListRE",
  //     page: 1,
  //     per_page: 10,
  //     searchTerm: "",
  //     rowFilter: filters.length > 0 ? { $and: filters } : {},
  //   };

  //   dispatch(materialBarcodeList(obj));
  // };

  const handleFilterData = async (filters) => {
  setActiveFilters(filters);   // ← save filters
  setMiniDay(null);            // ← clear bucket when column filter applied
  setMaxDay(null);
  const obj = {
    queryName: "MaterilBarcodeListRE",
    page: 1,
    per_page: getNewPerPage,
    searchTerm: "",
    rowFilter: filters.length > 0 ? { $and: filters } : {},
  };
  dispatch(materialBarcodeList(obj));
};
  // const columnsForFilter = columns
  //   .filter((col) => col.id || col.selectorKey)
  //   .map((col) => ({
  //     name: col.name,
  //     selectorKey: col.id || col.selectorKey,
  //     dropDown: col.dropDown || false,
  //     range: col.range || false,
  //     month: col.month || false,
  //   }));
  const columnsForFilter = [
  { id: "barcode",              name: "Barcode Code", selectorKey: "barcode" },
  { id: "materialCode",         name: "Code",         selectorKey: "materialCode" },
  { id: "orderPriceUnit",       name: "Rate",         selectorKey: "orderPriceUnit", numberRange: true },
  { id: "materialStatus",       name: "Stock",        selectorKey: "materialStatus" },
  { id: "materialDescription",  name: "Material",     selectorKey: "materialDescription" },
  { id: "createdOn",            name: "Date",         selectorKey: "createdOn", month: true },
];
const clearRentAging = async () => {
  setMaxDay(null);
  setMiniDay(null);
  setActiveFilters([]); // ← add this
  const obj = {
    queryName: "MaterilBarcodeListRE",
    page: 1,
    per_page: 10,
  };
  dispatch(materialBarcodeList(obj));
};
  // const clearRentAging = async () => {
  //   const obj = {
  //     queryName: "MaterilBarcodeListRE",
  //     page: 1,
  //     per_page: 10,
  //   };
  //   setMaxDay(null);
  //   setMiniDay(null);
  //   dispatch(materialBarcodeList(obj));
  // };
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Rent Idle Goods Ageing</h2>
                <p className="subText">Rent Idle Goods Ageing</p>
              </Col>
              <Col
                xs={12}
                md={3}
                lg={3}
                className="d-flex justify-content-end mt-3"
              >
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={12} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                data={getData}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}
            <Row className="mb-2 g-1">
              <Col md={2}>
                <AgeCard
                  title="Bucket 0–30 days"
                  // count={
                  //   materialData.filter(
                  //     (r) => r.ageingDays >= 0 && r.ageingDays <= 30,
                  //   ).length
                  // }
                  count={
                    (
                      getTotlaMaterialBarcode?.filter(
                        (r) => r.ageingDays >= 0 && r.ageingDays <= 30,
                      ) || []
                    ).length
                  }
                  colorClass="text-primary"
                  onClick={() => handleBucketClick(0, 30, "0-30")}
                />
              </Col>

              <Col md={2}>
                <AgeCard
                  title="Bucket 31–60 days"
                  // count={
                  //   materialData.filter(
                  //     (r) => r.ageingDays >= 31 && r.ageingDays <= 60,
                  //   ).length
                  // }
                  count={
                    (
                      getTotlaMaterialBarcode?.filter(
                        (r) => r.ageingDays >= 31 && r.ageingDays <= 60,
                      ) || []
                    ).length
                  }
                  colorClass="text-primary"
                  onClick={() => handleBucketClick(31, 60, "31-60")}
                />
              </Col>

              <Col md={2}>
                <AgeCard
                  title="Bucket 61–90 days"
                  // count={
                  //   materialData.filter(
                  //     (r) => r.ageingDays >= 61 && r.ageingDays <= 90,
                  //   ).length
                  // }
                  count={
                    (
                      getTotlaMaterialBarcode?.filter(
                        (r) => r.ageingDays >= 61 && r.ageingDays <= 90,
                      ) || []
                    ).length
                  }
                  colorClass="text-primary"
                  onClick={() => handleBucketClick(61, 90, "61-90")}
                />
              </Col>

              <Col md={2}>
                <AgeCard
                  title="Bucket 91–180 days"
                  // count={
                  //   materialData.filter(
                  //     (r) => r.ageingDays >= 91 && r.ageingDays <= 180,
                  //   ).length
                  // }
                  count={
                    (
                      getTotlaMaterialBarcode?.filter(
                        (r) => r.ageingDays >= 91 && r.ageingDays <= 180,
                      ) || []
                    ).length
                  }
                  colorClass="text-warning"
                  onClick={() => handleBucketClick(91, 180, "91-180")}
                />
              </Col>

              <Col md={2}>
                <AgeCard
                  title="Bucket 181–365 days"
                  // count={
                  //   materialData.filter(
                  //     (r) => r.ageingDays >= 181 && r.ageingDays <= 365,
                  //   ).length
                  // }
                  count={
                    (
                      getTotlaMaterialBarcode?.filter(
                        (r) => r.ageingDays >= 181 && r.ageingDays <= 365,
                      ) || []
                    ).length
                  }
                  colorClass="text-danger"
                  onClick={() => handleBucketClick(181, 365, "181-365")}
                />
              </Col>

              <Col md={2}>
                <AgeCard
                  title="Bucket > 365 days"
                  // count={materialData.filter((r) => r.ageingDays > 365).length}
                  count={
                    (
                      getTotlaMaterialBarcode?.filter(
                        (r) => r.ageingDays > 365,
                      ) || []
                    ).length
                  }
                  colorClass="text-dark"
                  onClick={() => handleBucketClick(365, "above", "Over 365")}
                />
              </Col>
            </Row>
            {/* material */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">MD</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">
                        Rent Idle Goods Ageing
                      </span>
                      <span className="subHeaderTitle">
                        Rent Idle Goods Ageing{" "}
                      </span>
                    </Col>
                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      <Col xs={3} md={3} lg={3} className="">
                        <button
                          className="btnTable d-flex justify-content-center"
                          onClick={clearRentAging}
                        >
                          <p className="m-0 me-2">
                            {" "}
                            <span className="mr-2">
                              {/* <i class="bi bi-upload"></i> */}
                            </span>
                            Clear Ageing
                          </p>
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    {activeBucket && (
                      <div className="mb-2 text-end">
                        <button
                          className="btn btn-sm btn-outline-secondary"
                          onClick={clearBucketFilter}
                        >
                          Clear Ageing Filter
                        </button>
                      </div>
                    )}
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={materialData}
                          // data={filteredData}
                          // progressPending={purchaseOrderData?.status}
                          paginationRowsPerPageOptions={
                            CustomerConstants.ROW_PER_PAGE
                          }
                          pagination
                          paginationServer
                           paginationPerPage={getNewPerPage}
                          paginationTotalRows={materialTable?.total || ""}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <MaterialListQualityCheckModal
        show={showQCModal}
        onHide={() => setShowQCModal(false)}
        qcType={qcType}
        rowData={selectedRow}
        // editMode={editMode}
        onSaveQualityCheck={handleSaveQualityCheck}
      />
    </main>
  );
};

export default RentMaterialAgeingReport;
